import * as React from "react";
import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import { IStore } from "reducers";
import { fetchEntries, fetchEntriesNextPage } from "actions/entries";
import { fetchCatalog } from "actions/catalog";
import * as actions from "actions/collections";
import { List } from "immutable";
import { ProductCollectionCatalog } from "components/product-collection/product-collection-side-panel/product-collection-catalog";
import { CollectionKeys } from "constants/product-collection";
import { viewDefData } from "components/product-collection/product-collection-views/product-collection-linesheet-view/dummy_view_def";
import * as ViewRecord from "records/view";
import { ISchemaKey, parseSchema, productsInAssortment } from "helpers/product-collection";
import CircularProgress from "material-ui/CircularProgress";
import { parseFilters } from "components/product-collection/product-collection-views/product-collection-grid-view/tool-panels/shop-tool-panel/helpers";
import CatalogEntryRecord from "records/catalog/catalog-entry";
import memoizeOne from "memoize-one";
import { formatMessage } from "lib/globalize-util";
import { ProductCollectionContext } from "components/product-collection/product-collection-context";
import { getRawItemDisplayProperty } from "helpers/collection";

const EMPTY_ENTITY_ENTRIES = {};
export const IN_ASSORTMENT = "__in_assortment";
export const NOT_INCLUDED = "0";
export const INCLUDED = "1";
interface IProps {
    onFetchEntries: (catalogId, cacheKey, filters, fromAssortment?) => void;
    onFetchEntriesNextPage: (catalogId, nextPage, fromAssortment?) => void;
    onAddItem: (params) => void;
    onFetchCatalog: (id) => void;
    entries: any;
    entities: any;
    itemsId?: string;
    items?: List<any>;
    collection: any;
    collectionEditable: boolean;
    app: any;
    brandEntities: any;
    catalog: any;
    isViewDefFetching: boolean;
    location: any;
    params: any;
    router: any;
    scope: any;
    itemDisplayProperty?: List<any>;
    allowDuplicateProduct: boolean;
}

type EntitiesType = { [key: string]: CatalogEntryRecord };
const DEFAULT_BRAND = undefined;

const filterInAssortment = (
    inAssortmentProducts: { [key: string]: string },
    entities: EntitiesType,
    expectedValue: boolean,
    result: string
) => {
    const productId = entities[result]?.get("item");
    return productId && !!inAssortmentProducts[productId] == expectedValue;
};

export const filterOutResults = (
    inAssortmentProducts: { [key: string]: string },
    entries,
    entities: EntitiesType,
    filterValue
) => {
    if (entries) {
        return {
            ...entries,
            results: entries.results.filter(
                filterInAssortment.bind(null, inAssortmentProducts, entities, filterValue === INCLUDED)
            ),
        };
    }
    return entries;
};

const memoizedFilterOutResults = memoizeOne(filterOutResults);
class ProductCollectionShopBrandCatalogView extends React.PureComponent<IProps, any> {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    private muiStyles = {
        circularProgress: {
            width: "100px",
            margin: "0px auto",
        },
    };

    constructor(props) {
        super(props);
        this.state = {
            inAssortmentProducts: productsInAssortment(props.items),
            ...parseSchema(props.itemDisplayProperty),
            changingBrands: false,
            filters: parseFilters(props.location),
        };
    }

    filterInclusions = [
        {
            __key: IN_ASSORTMENT,
            __type: "radio",
            __name: formatMessage("Assortment Status"), // add to en.json
            __data: [
                {
                    __label: formatMessage("All Products"),
                    __value: "",
                    __default: true,
                },
                {
                    __label: formatMessage("Not in Assortment"),
                    __value: NOT_INCLUDED,
                },
                {
                    __label: formatMessage("In Assortment"),
                    __value: INCLUDED,
                },
            ],
        },
    ];

    componentDidMount() {
        const { router, collection } = this.props;

        const collectionBrandId = collection.getIn(["brand_collection_properties", "struct_value", "brand_id"]);
        if (collectionBrandId && collectionBrandId !== router.params.brand) {
            router.push(`/assortment/${router.params.id}/shop/brand/${collectionBrandId}`);
        }
        // Fetch Catalog
        this.props.onFetchCatalog(router.params.catalog);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.items !== nextProps.items) {
            this.setState({
                inAssortmentProducts: productsInAssortment(nextProps.items),
            });
        }

        if (this.props.itemDisplayProperty !== nextProps.itemDisplayProperty) {
            this.setState(parseSchema(nextProps.itemDisplayProperty));
        }

        if (nextProps.location.search !== this.props.location.search) {
            const { location } = nextProps;
            const filters = parseFilters(location);
            this.setState({ filters });
        }

        if (nextProps.scope.brand._id !== this.props.scope.brand._id) {
            this.setState({ changingBrands: true });
        }
    }

    render() {
        const {
            app,
            router,
            scope,
            onFetchEntries,
            entities,
            entries,
            isViewDefFetching,
            onAddItem,
            onFetchEntriesNextPage,
            itemsId,
            items,
            collectionEditable,
            catalog,
            allowDuplicateProduct,
            itemDisplayProperty,
            brandEntities,
        } = this.props;

        viewDefData.brand = router.params.brand;
        const viewDefRecord = new ViewRecord.default(viewDefData);
        const rawItemDisplayProperty: ISchemaKey[] = getRawItemDisplayProperty(itemDisplayProperty);

        const viewDef = {
            error: undefined,
            isFetching: false,
            // @ts-ignore
            result: [viewDefRecord._id],
        };
        const viewDefs = {
            // @ts-ignore
            [viewDefRecord._id]: viewDefRecord,
        };

        if (this.state.changingBrands) {
            return (
                <div style={this.muiStyles.circularProgress}>
                    <CircularProgress />
                </div>
            );
        }
        const { filters } = this.state;
        return (
            <ProductCollectionContext.Consumer>
                {({ shopViewSettings }) => (
                    <ProductCollectionCatalog
                        catalog={catalog}
                        app={app}
                        entities={entities}
                        entries={
                            (filters.get(IN_ASSORTMENT) ?? "") === ""
                                ? entries
                                : memoizedFilterOutResults(
                                      this.state.inAssortmentProducts,
                                      entries,
                                      entities.entries ?? EMPTY_ENTITY_ENTRIES,
                                      filters.get(IN_ASSORTMENT)
                                  )
                        }
                        inAssortmentProducts={this.state.inAssortmentProducts}
                        isViewDefFetching={isViewDefFetching}
                        itemsId={itemsId}
                        items={items}
                        location={location}
                        onAddItem={onAddItem}
                        onFetchEntries={onFetchEntries}
                        onFetchEntriesNextPage={onFetchEntriesNextPage}
                        scope={scope}
                        sidePanelWidth={500}
                        viewDef={viewDefRecord}
                        viewDefEntities={viewDefs}
                        viewDefIds={viewDef.result}
                        collectionEditable={collectionEditable}
                        router={router}
                        filters={filters}
                        additionalFilters={this.filterInclusions}
                        fromAssortment={true}
                        allowDuplicateProduct={allowDuplicateProduct}
                        shopViewFields={this.state.shopViewFields}
                        itemDisplayProperty={itemDisplayProperty}
                        brandEntities={brandEntities}
                        shopViewSettings={shopViewSettings}
                        rawItemDisplayProperty={rawItemDisplayProperty}
                    />
                )}
            </ProductCollectionContext.Consumer>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps) => {
    let catalog;
    if (state.catalog.result.length) {
        catalog = state.catalog.entities.catalogs[state.catalog.result];
    }

    const collection = state.mutate.snapshots && state.mutate.snapshots.get(ownProps.router.params.id);
    const itemsId = collection ? collection.getIn(["items", "ref", "object_id"]) : undefined;
    const items = state.mutate.snapshots && collection && state.mutate.snapshots.get(itemsId);
    const itemDisplayProperty = collection ? collection.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.KEYS) : List();
    const allowDuplicateProduct = collection?.getIn(
        CollectionKeys.ITEM_DISPLAY_PROPERTY.ALLOW_DUPLICATE_PRODUCT_ENTRIES
    );
    const capabilities = state.collection?.driveItem?.capabilities;
    const collectionEditable = capabilities?.can_edit || false;

    return {
        entries: state.entries.collections[ownProps.router.params.catalog] || {
            results: [],
            isFetching: false,
            hasMoreResults: false,
            isBulkDeleting: false,
        },
        entities: state.entities,
        catalog,
        collection,
        collectionEditable,
        itemsId,
        items,
        app: state.app,
        brandEntities: state.entities.brands,
        isViewDefFetching: state.views.isFetching,
        scope: state.scope,
        itemDisplayProperty,
        allowDuplicateProduct,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onFetchCatalog: (catalogId) => dispatch(fetchCatalog(catalogId)),
        onFetchEntries: (catalogId, cacheKey, filters, fromAssortment?) =>
            dispatch(fetchEntries(catalogId, cacheKey, catalogId, filters, DEFAULT_BRAND, false, fromAssortment)),
        onFetchEntriesNextPage: (catalogId, nextPage, fromAssortment?) =>
            dispatch(fetchEntriesNextPage(catalogId, nextPage, fromAssortment)),
        onAddItem: (params) => dispatch(actions.addItem(params)),
    };
};

export const ProductCollectionShopBrandCatalog = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductCollectionShopBrandCatalogView);
export default ProductCollectionShopBrandCatalog;
